import notificationsActionTypes from './actionTypes';

export interface NotificationOptions {
  statusType?: 'info' | 'warning' | 'error' | 'success';
  duration?: number;
}

function addNotification(message: string, options: NotificationOptions) {
  return {
    type: notificationsActionTypes.NOTIFICATIONS_QUEUE_NOTIFICATION,
    message,
    options,
  };
}

function removeNotification() {
  return {
    type: notificationsActionTypes.NOTIFICATIONS_DEQUEUE_NOTIFICATION,
  };
}

function purgeNotifications() {
  return {
    type: notificationsActionTypes.NOTIFICATIONS_PURGE_QUEUE,
  };
}

export default {
  addNotification,
  removeNotification,
  purgeNotifications,
};
